"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const faAngleRight_1 = require("@fortawesome/free-solid-svg-icons/faAngleRight");
const SurveyContext_1 = require("../../contexts/SurveyContext");
const helpers_1 = require("evolution-common/lib/utils/helpers");
const SectionNav = function ({ activeSection, sections, onChangeSection, interview, allWidgetsValid, user }) {
    const { devMode, dispatch } = react_1.default.useContext(SurveyContext_1.SurveyContext);
    const { i18n, t } = (0, react_i18next_1.useTranslation)();
    const loadingState = (0, react_redux_1.useSelector)((state) => state.loadingState.loadingState);
    (0, helpers_1.devLog)('%c rendering section nav', 'background: rgba(0,255,255,0.1); font-size: 7px;');
    const sectionShortnames = Object.keys(sections);
    const completedStatusBySectionShortname = {};
    const sectionNavLinks = [];
    let firstSectionShortname = null;
    // Determine which section is the active one in the menu for the navigation
    const activeSectionConfig = sections[activeSection];
    const activeMenuSection = activeSectionConfig.navMenu.type === 'inNav' ? activeSection : activeSectionConfig.navMenu.parentSection;
    // FIXME Extract the sections to navigate and their status to a function, but not now as we may revisit the structure of the survey flow
    for (let i = 0, count = sectionShortnames.length; i < count; i++) {
        const sectionShortname = sectionShortnames[i];
        firstSectionShortname = firstSectionShortname || sectionShortname;
        const sectionConfig = sections[sectionShortname];
        const previousSection = sectionConfig.previousSection;
        const previousSectionCompleted = previousSection ? !!completedStatusBySectionShortname[previousSection] : true;
        const enabled = previousSectionCompleted === false
            ? false
            : (0, helpers_1.parseBoolean)(sectionConfig.enableConditional, interview, sectionShortname); // previous section must be completed
        const completed = previousSectionCompleted === false
            ? false
            : (0, helpers_1.parseBoolean)(sectionConfig.completionConditional, interview, sectionShortname);
        completedStatusBySectionShortname[sectionShortname] = completed;
        // Display in the navigation if the section is a top-level one
        if (sectionConfig.navMenu.type === 'inNav') {
            // Add a separator before adding the link if it is not the first section
            if (sectionNavLinks.length > 0) {
                sectionNavLinks.push(react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faAngleRight_1.faAngleRight, style: { marginRight: '0.5rem', marginLeft: '0.5rem' }, key: `sectionNavLinkArrowSeparator__${sectionShortname}` }));
            }
            sectionNavLinks.push(react_1.default.createElement("button", { type: "button", key: `sectionNavLink__${sectionShortname}`, className: `nav-button${sectionShortname === activeMenuSection ? ' active-section' : ''}${completed === true ? ' completed-section' : ''}`, onClick: enabled && loadingState === 0
                    ? () => onChangeSection(sectionShortname, activeSection, allWidgetsValid)
                    : () => {
                        return;
                    }, disabled: !enabled || loadingState > 0 }, (0, helpers_1.translateString)(sectionConfig.navMenu.menuName, i18n, interview, sectionShortname)));
        }
    }
    return (react_1.default.createElement("div", { className: "survey-section-nav" },
        sectionNavLinks,
        user && user.isAuthorized({ Interviews: ['confirm'] }) && (react_1.default.createElement(react_1.default.Fragment, null,
            ' ',
            "\u2022",
            ' ',
            react_1.default.createElement("button", { type: "button", className: "menu-button _oblique _red", key: 'header__nav-devMode', onClick: () => dispatch({ type: 'setDevMode', value: !devMode }) }, t(devMode ? 'menu:setDevModeOff' : 'menu:setDevModeOn'))))));
};
exports.default = SectionNav;
//# sourceMappingURL=SectionNav.js.map